import React, { useState } from "react";
import ClubInfo from "./ClubInfo";

function ScoreBoard({
  score,
  setBlur,
  blur,
  criteriaChecked,
  shouldWatch,
  selectedClub,
}) {
  if (score === null) {
    return (
      <div>
        <h3>Loading...</h3>
      </div>
    );
  }

  const scoreData = score.response[0];

  const homeTeam = scoreData.teams.home;
  const awayTeam = scoreData.teams.away;
  const homeTeamScore = scoreData.goals.home;
  const awayTeamScore = scoreData.goals.away;
  const longStatus = scoreData.fixture.status.long;
  const shortStatus = scoreData.fixture.status.short;
  const league = scoreData.league.name;
  const timestamp = scoreData.fixture.timestamp;
  const date = new Date(timestamp * 1000);
  const formattedDate = date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });

  let text = "";
  let icon = "";
  if (!criteriaChecked) {
    icon = "/images/chevron-top.png";
    text = "First, you need to fill out the criteria above";
  } else if (shouldWatch) {
    icon = "/images/thumbs-up.png";
    text = "Based on your criteria, you should watch the game";
  } else {
    icon = "/images/thumbs-down.png";
    text = "Based on your criteria, you can skip the game";
  }

  return (
    <div id="scoreboard" className="flex-column section-container">
      <h3>Showing {selectedClub.name}'s most recent played fixture</h3>{" "}
      <div
        className={`flex-column score-card-container ${
          shouldWatch ? "extra-padding" : ""
        }`}
      >
        <div className="flex-column decision-wrap">
          <div className="decision-icon-wrap">
            <img className="decision-icon" src={icon} />
          </div>
          <span className="decision-text">{text}</span>
        </div>
        <div className="flex-row score-wrap">
          <ClubInfo team={homeTeam} />
          <div className="flex-column fixture-info-wrap">
            <div className="flex-row metadata-wrap">
              <span className="info small">{formattedDate}</span>
              <div className="separator"></div>
              <span className="info small">{league}</span>
            </div>
            <div className="flex-row">
              <span className={`goal-count${blur ? " blurred extra" : ""}`}>
                {blur ? "x" : homeTeamScore}
              </span>
              <span className={`goal-count${blur ? " blurred" : ""}`}>:</span>
              <span className={`goal-count${blur ? " blurred extra" : ""}`}>
                {blur ? "x" : awayTeamScore}
              </span>
            </div>
            <span className="info small">
              {shortStatus} - {longStatus}
            </span>
          </div>
          <ClubInfo team={awayTeam} />
        </div>
        {shouldWatch === false && (
          <button className="button-primary" onClick={() => setBlur(false)}>
            Reveal score
          </button>
        )}
      </div>
    </div>
  );
}

export default ScoreBoard;
